import React, {useEffect} from "react";


import { useDispatch } from 'react-redux'
import {logoutUser, checkUserAuth} from "@/reducers/Authorisation"

import * as UserConst from "actions/userConst";

export default function AppLogin({...props}) {
const dispatch = useDispatch();
    const logout  = (event) => {
        event.stopPropagation();
        event.preventDefault()

    
    dispatch( logoutUser() );
    return false;
    }

useEffect(() => {
                if(props.authReducer.isAuth === false && props.authReducer.status == UserConst.USER_STATE_INIT) {
                //await store.dispatch(checkUserAuth());
                dispatch( checkUserAuth() );
            }
        
    });


    let username = "";
    let tenantName = "";
    let tenantId = 0;
    if(props.authReducer && props.authReducer.user && props.authReducer.user) {
        username = props.authReducer.user.initials+" "+props.authReducer.user.last_name;
    }
    if(props.authReducer && props.authReducer.tenant && props.authReducer.tenant.name) {
        tenantName = props.authReducer.tenant.name;
        tenantId = props.authReducer.tenant.id;
    }
    
    
  return (
      <>
      {props.children}
      </>
  )
}